<div>
    <mat-toolbar>
        <h3>{{ data.message }}</h3>
    </mat-toolbar>
        <mat-dialog-content>
            <br/>
            <br/>
            <br/>
        </mat-dialog-content>
        <mat-dialog-actions fxLayout="row" fxLayoutAlign="center center">
            <button mat-dialog-close mat-button color="secondary">{{ "cancel" | translate }}</button>
            <button id="ConfirmModal__submitButton" [mat-dialog-close]="'true'" mat-button color="primary" cdkFocusInitial>{{ "confirm" | translate }}</button>
        </mat-dialog-actions>
  </div>